import { render, staticRenderFns } from "./edit-license.vue?vue&type=template&id=82227a08&"
import script from "./edit-license.vue?vue&type=script&lang=js&"
export * from "./edit-license.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports